import React, { useEffect } from "react";
import "./index.scss";

export default function HexagonBar({ per }) {
  const forEach = function (array, callback, scope) {
    for (let i = 0; i < array.length; i++) {
      callback.call(scope, i, array[i]);
    }
  };
  
  useEffect(() => {
    const max = 2160;
    forEach(document.querySelectorAll(".progress"), function (index, value) {
      const percent = value.getAttribute("data-progress");
      value
        .querySelector(".fill")
        .setAttribute(
          "style",
          `stroke-dashoffset: ${((100 - percent) / 100) * max}`
        );
    });
  }, [per]);

  return (
    <div id="wrapper" className="center">
      <svg
        className="progress blue noselect"
        data-progress={per}
        x="0px"
        y="0px"
        viewBox="0 0 776 628"
      >
        <path
          className="track"
          d="M723 314L543 625.77 183 625.77 3 314 183 2.23 543 2.23 723 314z"
        ></path>
        <path
          className="fill"
          d="M723 314L543 625.77 183 625.77 3 314 183 2.23 543 2.23 723 314z"
        ></path>
      </svg>
    </div>
  );
}
